import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indianNumber'
})
export class IndianNumberPipe implements PipeTransform {

  transform(value: number): string {
    if (isNaN(value)) {
      return '';
  }

  const formattedNumber = value.toLocaleString('en-IN');
  return formattedNumber;
  }
}
